import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiAccordion: Components<CssVarsTheme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: 'transparent',
      '&.Mui-expanded': {
        boxShadow: theme.vars.customShadows.z8,
        borderRadius: 8,
        backgroundColor: theme.vars.palette.background.paper
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent'
      }
    })
  }
};

export const MuiAccordionDetails: Components<CssVarsTheme>['MuiAccordionDetails'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: `${theme.vars.palette.background.paper} !important`,
      padding: '16px !important',
      borderRadius: '0.5rem',
      margin: '0 8px 8px 8px !important',
      '& .MuiTypography-root': {
        color: 'inherit'
      },
      '& .MuiList-root': {
        padding: 0
      }
    })
  }
};

export const MuiAccordionSummary: Components<CssVarsTheme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: '0px !important',

      padding: '8px !important',
      margin: '0 !important',
      '&.Mui-disabled': {
        opacity: 1,
        color: theme.vars.palette.text.disabled,
        '& .MuiTypography-root': {
          color: 'inherit'
        }
      }
    }),
    content: {
      margin: '0 !important',
      '& .MuiTypography-root': {
        color: 'inherit'
      }
    },
    expandIconWrapper: {
      color: 'inherit'
    }
  }
};
